// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.manage-friend-requests .request-tab {
  font-size: 1rem;
  color: #555;
  padding: 0.5rem;
  text-align: center;
}

.manage-friend-requests .active-tab {
  color: #ff8c00;
  /* border-bottom: 2px solid #ff8c00; */
}

.friendRequestButtons {
  display: flex;
  align-content: space-between;
  margin: 1px;
  padding: 1px;
}

.AddRequestButtonBorder {
  border-right: 1px solid #dcdcdc;
}

.cancelButton {
  border: none;
  background-color: #fb4e66;
  color: "white";
}

.request-card {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  padding-inline: 16px;
}

.acceptButton {
  background-color: #0bbc35;
  color: white;
  margin-top: 20px;
  padding: 7px 21px;
}

/* .acceptButton:hover {
  box-shadow: 2px 2px #ff8c00;
} */

/* .acceptButton:active {
  box-shadow: 2px 2px lightblue;
} */

.declineButton {
  background-color: #fb4e66;
  color: white;
  padding: 1px;
  margin-top: 20px;
  padding: 7px 21px;
}

/* .declineButton:hover {
  box-shadow: 2px 2px #ff8c00;
} */

/* .declineButton:active {
  box-shadow: 2px 2px lightblue;
} */

.online-indicator {
  width: 8px;
  height: 8px;
  border-radius: 50%;
  position: absolute;
  bottom: 0;
  right: 0;
  border: 1px solid white;
}
`, "",{"version":3,"sources":["webpack://./src/Pages/BuzzCom/components/FriendComponents/ManageFriendRequests.css"],"names":[],"mappings":"AAAA;EACE,eAAe;EACf,WAAW;EACX,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,sCAAsC;AACxC;;AAEA;EACE,aAAa;EACb,4BAA4B;EAC5B,WAAW;EACX,YAAY;AACd;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,YAAY;EACZ,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,oBAAoB;AACtB;;AAEA;EACE,yBAAyB;EACzB,YAAY;EACZ,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;;GAEG;;AAEH;;GAEG;;AAEH;EACE,yBAAyB;EACzB,YAAY;EACZ,YAAY;EACZ,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;;GAEG;;AAEH;;GAEG;;AAEH;EACE,UAAU;EACV,WAAW;EACX,kBAAkB;EAClB,kBAAkB;EAClB,SAAS;EACT,QAAQ;EACR,uBAAuB;AACzB","sourcesContent":[".manage-friend-requests .request-tab {\n  font-size: 1rem;\n  color: #555;\n  padding: 0.5rem;\n  text-align: center;\n}\n\n.manage-friend-requests .active-tab {\n  color: #ff8c00;\n  /* border-bottom: 2px solid #ff8c00; */\n}\n\n.friendRequestButtons {\n  display: flex;\n  align-content: space-between;\n  margin: 1px;\n  padding: 1px;\n}\n\n.AddRequestButtonBorder {\n  border-right: 1px solid #dcdcdc;\n}\n\n.cancelButton {\n  border: none;\n  background-color: #fb4e66;\n  color: \"white\";\n}\n\n.request-card {\n  display: flex;\n  align-items: center;\n  gap: 0.5rem;\n  padding-inline: 16px;\n}\n\n.acceptButton {\n  background-color: #0bbc35;\n  color: white;\n  margin-top: 20px;\n  padding: 7px 21px;\n}\n\n/* .acceptButton:hover {\n  box-shadow: 2px 2px #ff8c00;\n} */\n\n/* .acceptButton:active {\n  box-shadow: 2px 2px lightblue;\n} */\n\n.declineButton {\n  background-color: #fb4e66;\n  color: white;\n  padding: 1px;\n  margin-top: 20px;\n  padding: 7px 21px;\n}\n\n/* .declineButton:hover {\n  box-shadow: 2px 2px #ff8c00;\n} */\n\n/* .declineButton:active {\n  box-shadow: 2px 2px lightblue;\n} */\n\n.online-indicator {\n  width: 8px;\n  height: 8px;\n  border-radius: 50%;\n  position: absolute;\n  bottom: 0;\n  right: 0;\n  border: 1px solid white;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
